import React from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarDays, Clock, Users } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const PointagesStatsCards = ({ totalPunches, totalEntries, totalExits, uniqueEmployeesCount }) => {
  const { t } = useTranslation();
  return (
  <div className="grid gap-4 md:grid-cols-4">
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <CalendarDays className="h-4 w-4 text-muted-foreground" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('pointages.stats.punches')}</p>
            <p className="text-2xl font-bold">{totalPunches}</p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Clock className="h-4 w-4 text-green-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('pointages.stats.entries')}</p>
            <p className="text-2xl font-bold text-green-600">{totalEntries}</p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Clock className="h-4 w-4 text-muted-foreground" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('pointages.stats.exits')}</p>
            <p className="text-2xl font-bold">{totalExits}</p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Users className="h-4 w-4 text-muted-foreground" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('pointages.stats.uniqueEmployees')}</p>
            <p className="text-2xl font-bold">{uniqueEmployeesCount}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
  );
};

export default PointagesStatsCards;
